import { Pipe, PipeTransform } from '@angular/core';
import { StatusPracyDyplomowej } from '@interfaces/dyplomowanie/enums/status-pracy.enum';

interface StatusInfo {
  [k: number]: { [v: string]: string };
}

@Pipe({
  name: 'statusPracy',
})
export class StatusPracyPipe implements PipeTransform {
  StatusPracy = StatusPracyDyplomowej;

  private statusInfo: StatusInfo = {
    [this.StatusPracy.WprowadzanieDanych]: {
      btnClassName: 'bg-neutral-500',
    },
    [this.StatusPracy.PrzekazanoDoAkceptacjiDane]: {
      btnClassName: 'bg-info',
    },
    [this.StatusPracy.WprowadzaniePlikow]: {
      btnClassName: 'bg-neutral-500',
    },
    [this.StatusPracy.PrzekazanoDoAkceptacjiPliki]: {
      btnClassName: 'bg-info',
    },
    [this.StatusPracy.WBadaniuJsa]: {
      btnClassName: 'bg-warning text-body',
    },
    [this.StatusPracy.WystawianieRecenzji]: {
      btnClassName: 'bg-warning text-body',
    },
    [this.StatusPracy.PracaGotowaDoObrony]: {
      btnClassName: 'bg-success',
    },
    [this.StatusPracy.PracaPoObronie]: {
      btnClassName: 'bg-success',
    },
  };

  transform(value: StatusPracyDyplomowej): string {
    return this.statusInfo[value]?.btnClassName || '';
  }
}
